// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nx-c";
export var backButton = "_nx-4";
export var backIcon = "_nx-5";
export var chevronShortcut = "_nx-6";
export var container = "_nx-1";
export var editor = "_nx-8";
export var editorWrapper = "_nx-7";
export var prefix = "_nx-2";
export var searchIcon = "_nx-3";
export var suffix = "_nx-9";
export var suffixContent = "_nx-a";
export var suffixText = "_nx-b";
export var wrapper = "_nx-0";